import DashboardLayout from "../../lib/components/layouts/dashboard";
import PatientBookTherapySession from "../../lib/components/therapysession/patient/patient-book-therapy-session";
import { useContext } from "react";
import { AppContext } from "lib/contexts/app-context";
import { isPatientUser } from "lib/utils/util";
import { PAGE_ROUTES } from "lib/constants/page-routes";

const PatientBookTherapySessionPage = () => {
  const { appState } = useContext(AppContext);

  const BreadcrumbItems = [
    {
      label: "Dashboard",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.Dashboard
        : PAGE_ROUTES.PRACTITIONER.Dashboard,
    },
    {
      label: "Book Therapy Session",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.BookTherapySession
        : PAGE_ROUTES.PATIENT.BookAppointment,
    },
  ] as BreadcrumbItem[];

  return (
    <DashboardLayout breadcrumbItems={BreadcrumbItems}>
      <PatientBookTherapySession />
    </DashboardLayout>
  );
};

export default PatientBookTherapySessionPage;
